import { render, staticRenderFns } from "./PackTypeSelector.vue?vue&type=template&id=38438af2&"
import script from "./PackTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PackTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports